<div style="width: 100%; display: grid;">
  @if (IsReport==0) {
    <div style="width: 100%;">
      @if (!isMyPost) {
        <ion-label style="color: white; font-size: 12px;float: right;"
          (click)="anyReport($event,PropertyId,StatusTypeId)">Any
        report</ion-label>
      }
    </div>
  }
  @if (IsReport==1) {
    <div style="width: 100%;">
      @if (!isMyPost) {
        <ion-label style="color: white; font-size: 12px;float: right;"
        (click)="Reported()">Reported</ion-label>
      }
    </div>
  }
  <div style="width: 100%;">

    <ion-label style="color: white; font-size: 12px;float: right;">{{calculateDiff(propDate)}} days
    ago</ion-label>
  </div>
</div>